import React, { useEffect, useRef, useState } from 'react';
import { DUMMY_ICONS } from '../../../constants/constantsDummy';
import { useOnClickOutside, useOnHover } from '../../../hooks';

interface TooltipProps extends React.PropsWithChildren {
  content: string | React.ReactNode;
  direction?: 'top' | 'bottom' | 'left' | 'right';
  delay?: number;
  icon?: React.ReactNode;
  showOnHover?: boolean;
  hideCloseIcon?: boolean;
  contentPosition?: 'absolute' | 'relative' | 'fixed';
  customClassName?: string;
}
const Tooltip: React.FC<TooltipProps> = (props) => {
  const hoverRef = useRef(null);
  const ref = useRef(null);
  const refHeight = useRef(null);
  const isHover = useOnHover(hoverRef);

  const [display, setDisplay] = useState(false);
  const [height, setHeight] = useState<number>(0);

  const topStyle = {
    top: `-${height + 8}px`,
  };

  useOnClickOutside(ref, () => setDisplay(false));

  useEffect(() => {
    if (refHeight.current) {
      setHeight(refHeight.current['clientHeight']);
    }
  }, [display]);

  return (
    <span
      data-testid="tooltip-wrapper"
      ref={hoverRef}
      className="Tooltip-Wrapper relative inline-flex items-center gap-1 "
      style={{ alignItems: 'baseline' }}
    >
      {props.children}
      <span
        onClick={() => {
          setDisplay((displayValue) => !displayValue);
        }}
        className="relative inline-flex items-center align-middle flex-shrink-0"
        ref={ref}
      >
        {props.icon}
      </span>
      {(display || (isHover && props.showOnHover)) && (
        <div
          data-testid="tooltip-content"
          ref={refHeight}
          style={props.direction === 'top' ? topStyle : {}}
          className={`Tooltip-Tip ${props.direction} ${props.contentPosition} ${
            props.customClassName ?? ''
          }`}
        >
          {!props.hideCloseIcon && (
            <span
              data-testid="tooltip-close"
              className="absolute top-0 right-0 my-3 mr-4 cursor-pointer"
              onClick={() => {
                setDisplay((displayValue) => !displayValue);
              }}
            >
              <img
                src={DUMMY_ICONS.closeButton}
                height={12}
                width={12}
                alt="close"
              />
            </span>
          )}
          {props.content}
        </div>
      )}
    </span>
  );
};

Tooltip.defaultProps = {
  icon: (
    <img
      src={DUMMY_ICONS.infoToolTip}
      height={16}
      width={16}
      alt="info"
      className="w-4 h-4 align-middle mt-[2px]"
    />
  ),
  showOnHover: false,
  direction: 'top',
  contentPosition: 'absolute',
};

export { Tooltip };
